import React, { useCallback, useEffect, useMemo } from 'react';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { PlusOutlined } from '@ant-design/icons';

import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import {
  Form,
  FormInstance,
  notification,
  Popconfirm,
  Switch,
  Tag,
} from 'antd';
import { useQuery } from 'react-query';
import Text from 'antd/lib/typography/Text';
import {
  createThirdPartyRole,
  deleteThirdPartyRoleByid,
  getThirdPartyRoleListByTpid,
  TpRoleListResponse,
  updateThirdPartyRole,
} from 'services/thirdParty';
import DeleteButton from 'components/DeleteButton';
import ModalController from 'components/ModalController';
import RoleModal from './RoleModal';
import FormInput from 'components/FormInput';
import { indexBy } from 'utils/utils2';
import FormulaList from 'components/FormulaList';
import ThirdPartyRoleStatusButton from './ThirdPartyRoleStatusButton';
import ButtonOperation from 'components/ButtonOperation';
type RoleListProps = {
  form: FormInstance;
  tpid: number;
  onClose?: any;
  disabled?: boolean;
  showAsModal?: boolean;
  refetech?: boolean;
  refetchTp?: () => void;
};

const RoleList = (props: RoleListProps) => {
  const { form, tpid, showAsModal, refetech } = props;
  const fieldName = 'RoleListComponents';

  const { data: Role, refetch } = useQuery(
    ['getThirdPartyRoleList', { tpid: Number(tpid) }],
    () =>
      getThirdPartyRoleListByTpid({ tpid: Number(tpid) }).then(
        (res) => res.list || []
      ),
    { enabled: !!tpid }
  );

  useEffect(() => {
    if (Role) {
      form.setFieldsValue({ [fieldName]: Role });
      refetch();
    } else {
      form.setFieldsValue({ [fieldName]: [] });
    }
  }, [form, Role, refetch, refetech]);

  const onSave = useCallback(
    (record: any, action?: string) => {
      if (action === 'create') {
        createThirdPartyRole({
          tproleRequest: { ...record, tpid },
          tpid: tpid,
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            refetch();
            form.setFieldsValue({ [fieldName]: Role });
            props.refetchTp && props.refetchTp();
          }
        });
      } else
        updateThirdPartyRole({
          tproleRequest: {
            ...record,
            status: record.status,
            statusdate: record.statusdate,
          },
          tproleid: Number(record.tproleid),
          tpid: tpid,
        }).then((response) => {
          if (response.code === '200') {
            notification.success({
              message: response.message,
            });
            refetch();
            form.setFieldsValue({ [fieldName]: Role });
            props.refetchTp && props.refetchTp();
          }
        });
    },
    [Role, form, props, refetch, tpid]
  );
  const getName = useCallback(
    (name: string) => (record: TpRoleListResponse) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions ?? [], 'tproleid')[record.tproleid];
      return [fieldName, index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<TpRoleListResponse>[]>(
    () => [
      {
        dataIndex: 'tprolecode',
        fixed: true,
        width: 150,
        render: (_value, _record, index) => (
          <ModalController>
            {({ setVisible, visible }) => (
              <>
                <a onClick={() => setVisible(true)}>{_record.tprolecode}</a>
                {tpid !== undefined &&
                  _record.status !== 'END' &&
                  _record.status !== 'DISABLED' && (
                    <RoleModal
                      showAsModal={showAsModal}
                      visible={visible}
                      onClose={() => {
                        setVisible(false);
                        refetch();
                      }}
                      onSave={(value) => {
                        onSave(value);
                        setVisible(false);
                        refetch();
                      }}
                      tpid={tpid}
                      record={_record}
                      initadd={initialValue}
                    />
                  )}
              </>
            )}
          </ModalController>
        ),
      },
      {
        dataIndex: 'address',
        width: 200,
        render: (_value, _record, index) => (
          <div>
            {_record.address?.tpmainadrregion}-{_record.address?.tpmainadrstreet1}
          </div>
        ),
        // render: (_value, _record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('address')(_record)}>
        //       <AddresseListSelect params={{ tpid }} display={display}/>
        //     </FormInput>
        //   </Form.Item>
        // ),
      },
      {
        dataIndex: 'tpbkidin',
        width: 200,
        render: (_value, _record, index) => (
          <div>
            {_record.bankAccountIn?.tpbankname}-{_record.bankAccountIn?.tpiban}
          </div>
        ),
        // render: (_value, _record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tpbkidin')(_record)}>
        //       <BankAccountListSelect params={{ tpid }} display />
        //     </FormInput>
        //   </Form.Item>
        // ),
      },

      {
        dataIndex: 'tppaymodeinlabel',
        width: 150,
        // render: (_value, record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tppaymodein')(record)}>
        //       <ParListSelect parcode="PAYMODEIN" value={_value} disabled/>
        //     </FormInput>
        //   </Form.Item>
        // ),
      },
      {
        dataIndex: 'tppaydelayinlabel',
        width: 150,
        // render: (_value, record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tppaydelayin')(record)}>
        //       <ParListSelect parcode="PAYDELAYIN" value={_value} disabled />
        //     </FormInput>
        //   </Form.Item>
        // ),
      },
      {
        dataIndex: 'tpbkidout',
        width: 200,
        render: (_value, _record, index) => (
          <div>
            {_record.bankAccountOut?.tpbankname}-
            {_record.bankAccountOut?.tpiban}
          </div>
        ),
        // render: (_value, _record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tpbkidout')(_record)}>
        //       <BankAccountListSelect params={{ tpid }} display/>
        //     </FormInput>
        //   </Form.Item>
        // ),
      },
      {
        dataIndex: 'tppaymodeoutlabel',
        width: 150,
        // render: (_value, record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tppaymodeout')(record)}>
        //       <ParListSelect parcode="PAYMODEOUT" value={_value} disabled/>
        //     </FormInput>
        //   </Form.Item>
        // ),
      },
      {
        dataIndex: 'tppaydelayoutlabel',
        width: 150,
        // render: (_value, record, index) => (
        //   <Form.Item>
        //     <FormInput noStyle name={getName('tppaydelayout')(record)}>
        //       <ParListSelect parcode="PAYDELAYOU" value={_value} disabled/>
        //     </FormInput>
        //   </Form.Item>
        // ),
      },

      {
        dataIndex: 'tplateinterestformula',
        width: 180,
        render: (_value, _record, index) => (
          <Form.Item>
            <FormInput noStyle name={getName('tplateinterestformula')(_record)}>
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'LATEIN',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
                value={_value}
                disabled
              />
            </FormInput>
          </Form.Item>
        ),
      },
      {
        dataIndex: 'tprejectionfeesformula',
        width: 180,
        render: (_value, _record, index) => (
          <Form.Item>
            <FormInput
              noStyle
              name={getName('tprejectionfeesformula')(_record)}
            >
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REJFEES',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
                value={_value}
                disabled
              />
            </FormInput>
          </Form.Item>
        ),
      },
      {
        dataIndex: 'tpreminderfeesformula',
        width: 180,
        render: (_value, _record, index) => (
          <Form.Item>
            <FormInput noStyle name={getName('tpreminderfeesformula')(_record)}>
              <FormulaList
                params={{
                  ctecategory: '',
                  ctetype: 'REMINF',
                  duration: 0,
                  finamount: 0,
                  priid: 0,
                  prilabel: '',
                  pristatus: '',
                }}
                value={_value}
                disabled
              />
            </FormInput>
          </Form.Item>
        ),
      },

      {
        dataIndex: 'tpblocklateinterestinvoicing',
        width: 180,
        render: (_value, _record, index) => (
          <FormInput
            col
            xs={6}
            noStyle
            name={getName('tpblocklateinterestinvoicing')(_record)}
            valuePropName="checked"
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              disabled
              defaultChecked={_record.tpblocklateinterestinvoicing}
            />
          </FormInput>
        ),
      },
      {
        dataIndex: 'tpblockrejectionfeesinvoicing',
        width: 180,
        render: (_value, _record, index) => (
          <FormInput
            col
            xs={6}
            noStyle
            name={getName('tpblockrejectionfeesinvoicing')(_record)}
            valuePropName="checked"
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              disabled
              defaultChecked={_record.tpblockrejectionfeesinvoicing}
            />
          </FormInput>
        ),
      },
      {
        dataIndex: 'tpblockreminderfeesinvoicing',
        width: 180,
        render: (_value, _record, index) => (
          <FormInput
            col
            xs={6}
            noStyle
            name={getName('tpblockreminderfeesinvoicing')(_record)}
            valuePropName="checked"
          >
            <Switch
              checkedChildren={<CheckOutlined />}
              unCheckedChildren={<CloseOutlined />}
              disabled
              defaultChecked={_record.tpblockreminderfeesinvoicing}
            />
          </FormInput>
        ),
      },
      {
        dataIndex: 'statusdate',
        width:  180,
        render: (_value, _record, index) => <Text>{_value}</Text>,
      },

      {
        dataIndex: 'status',
        width:  180,
        render: (_value, _record, index) => (
          <span>
            {_record.status?.split(',').map((tag) => {
              let color;

              if (tag === 'VALID') {
                color = 'green';
              }
              if (tag === 'DISABLED') {
                color = ' #ffcc00';
              }
              if (tag === 'END') {
                color = 'red';
              }

              return (
                <Tag color={color} key={tag}>
                  {_record.status}
                </Tag>
              );
            })}
          </span>
        ),
      },

      {
        dataIndex: 'actions',
        key: 'actions',
        render: (_, _record) => (
          <>
            <ThirdPartyRoleStatusButton
              tpid={_record.tpid}
              tproleid={_record.tproleid}
              status={_record.status}
              refetch={refetch}
            />
            {localStorage.getItem('userrole') === 'ADMIN' && (
              <Popconfirm
                title="Sure to delete?"
                okText="Yes"
                cancelText="No"
                onConfirm={async () => {
                  await deleteThirdPartyRoleByid({
                    tproleid: _record.tproleid,
                    tpid: _record.tpid,
                  }).then((res) => {
                    notification.success({ message: res.message });
                    refetch();
                    props.refetchTp && props.refetchTp();
                  });
                }}

              >
                <DeleteButton
                  onlyIcon
                  style={{ height: '40px', width: '40px' }}
                  htmlType="button"
                />
              </Popconfirm>
            )}
          </>
        ),
        width:  180,
        fixed: 'right',
      },
    ],
    [getName, onSave, refetch, showAsModal, tpid]
  );

  return (
    <Form form={form}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          return (
            <DataGrid
              rowKey="tproleid"
              dataSource={Role}
              columns={
                !showAsModal
                  ? columns
                  : columns.filter((cl) => cl.key !== 'actions')
              }
              hideFilters
              extraActions={
                <ModalController>
                  {({ setVisible, visible }) => (
                    <>
                      {!showAsModal && (
                        <ButtonOperation
                          type="primary"
                          icon={<PlusOutlined />}
                          comcode="addRole"
                          onClick={(ev) => {
                            setVisible(true);
                            ev.stopPropagation();
                          }}
                        />
                      )}

                      <RoleModal
                        visible={visible}
                        onClose={() => {
                          setVisible(false);
                          refetch();
                        }}
                        onSave={(value) => {
                          if (
                            !Role?.find(
                              (role) => role.tprolecode === value.tprolecode
                            )
                          ) {
                            onSave(value, 'create');
                            setVisible(false);
                            refetch();
                          } else
                            notification.error({
                              message:
                                "can't add more than" +
                                value.tprolecode +
                                ' for a thirdparty',
                            });
                        }}
                        tpid={tpid}
                        initadd={initialValue}
                      />
                    </>
                  )}
                </ModalController>
              }
            />
          );
        }}
      </Form.Item>
    </Form>
  );
};
const initialValue = {
  enddate: '',
  startdate: '',
  status: '',
  statusdate: '',
  tpadrid: 0,
  tpblocklateinterestinvoicing: true,
  tpblockrejectionfeesinvoicing: true,
  tpblockreminderfeesinvoicing: true,
  tpid: 0,
  tplateinterestformula: '',
  tppaydelayin: '',
  tppaydelayout: '',
  tppaymodein: '',
  tppaymodeout: '',
  tprejectionfeesformula: '',
  tpreminderfeesformula: '',
  tprolecode: '',
  tproleid: 0,
};
export default RoleList;
